import { updateWorkerStatus } from 'redux/actions/backendStatus';
import WorkerStatusCode, { getDisplayText } from 'const/enums/WorkerStatusCode';
import WorkerGpuType from 'const/enums/WorkerGpuType';

// Handles the per-experiment heartbeat channel, which both the GPU and the non-GPU worker
// publish on. Beats say which worker they came from, so one subscription for the whole
// experiment can attribute all of them - including the ones carrying no task name, which
// are sent while the analysis object is downloading and belong to no task yet.
//
// This is deliberately not per request: a worker's status has to be readable by every task
// queued on it, and it has to survive a page reload or a task submitted from somewhere
// this tab never saw.
var workerHeartbeatHandler = function workerHeartbeatHandler(dispatch) {
  return function (experimentId, message) {
    var _getDisplayText;
    var gpu = message.gpu,
      statusCode = message.statusCode,
      taskName = message.taskName,
      progress = message.progress;

    // A worker that predates the gpu field. Its beats can't be placed, and guessing is
    // what this replaced, so drop them.
    if (typeof gpu !== 'boolean') return;
    var workerGpuType = gpu ? WorkerGpuType.GPU : WorkerGpuType.NON_GPU;
    dispatch(updateWorkerStatus(experimentId, workerGpuType, {
      statusCode: statusCode,
      // Empty on the cold-start beats: the worker is up but hasn't taken a task yet.
      taskName: taskName || null,
      progress: statusCode === WorkerStatusCode.STARTED_TASK ? progress !== null && progress !== void 0 ? progress : null : null,
      // Coalesce to null so an unrecognized status code clears any stale message
      // instead of leaving it on screen — the reducer's merge ignores undefined.
      userMessage: (_getDisplayText = getDisplayText(statusCode, taskName)) !== null && _getDisplayText !== void 0 ? _getDisplayText : null
    }));
  };
};
export default workerHeartbeatHandler;